export { default as ExpressPay } from './express-pay'
export type { ExpressPayProps } from './express-pay'
export type { ExpressPayConfig } from './express-pay.types'
